import { Checkbox, FormControl, FormControlLabel, FormLabel } from "@mui/material";
import { ChangeEvent } from "react";
import { useDispatch, useSelector } from "../../hooks";
import { settingsSet } from "../../redux/actions/settingsSetAction";
import { ISettings } from "../Sessings/Settings";

export interface IFilterSets {
    approvedDividends: boolean,
    applicabilityStrategy: boolean,
}

export const Filter = () => {
    const dispatch = useDispatch();
    const settings = useSelector(store => store.settings);
    
    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>, filter: string) => {
        const newSettings: ISettings = {
            sortOrder: settings.sortOrder,
            filterSets: { ...settings.filterSets, [filter]: event.target.checked }
        };
        dispatch(settingsSet(newSettings));
    };

    return (
        <FormControl sx={{ marginBottom: "10pt" }}>
            <FormLabel id="filter-setting">Фильтр</FormLabel>
            <FormControlLabel control={
                    <Checkbox checked={ settings.filterSets.approvedDividends } onChange={ (event) => handleCheckboxChange(event, 'approvedDividends') } />
                }
                label="Утвержденные дивиденды" />
            <FormControlLabel control={
                    <Checkbox checked={ settings.filterSets.applicabilityStrategy } onChange={ (event) => handleCheckboxChange(event, 'applicabilityStrategy') } />
                }
                label="Применимость стратегии" />
        </FormControl>
    );
}